import { useState } from "react";
import { Modal } from "react-bootstrap";
import { ArrowLeftRight, PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import Table, { Column } from "../../Components/Tables/Table";
import { inboundPurchaseOrderList } from "../../Data/testData";
import PageHeader from "../../Layout/PageHeader";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";
import ImportLayout from "../../Layout/ImportLayout";
import ExportLayout from "../../Layout/ExportLayout";
import CommonModal from "../../Components/Modals/CommonModal";

export default function PurchaseOrderOverview() {
  const pageName = "Purchase Order";
  const navigation = useNavigate();
  const [showModalForImportAndExport, setShowModalForImportAndExport] =
  useState({
    importModal: false,
    exportModal: false,
  });
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);
  const [isAddButtonDisable, setAddButtonDisable] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showconfModal, setShowconfModal] = useState(false);
  const handleconfShow = () => setShowconfModal(true);
  const handleconfClose = () => setShowconfModal(false);
  const handleConfirm = () => {
    console.log("Confirmed!");
    handleconfClose();
  };
  const handleconfCancel = () => {
    console.log("Cancelled!");
    handleconfClose();
  };
  const handelDeleteAction = (data: any) => {
    setShowconfModal(true);
  };

  const columns: Column[] = [
    {
      name: "PO #",
      selector: (row: { po: string }) =>(<div className="cursor-pointer text-primary">{row.po}</div>), 
    },
    {
      name: "Supplier ",
      selector: (row: { supplier: string }) => row.supplier,
    },
    {
      name: "Lines ",
      selector: (row: { lines: string }) => row.lines,
    },
    {
      name: "Date Created",
      selector: (row: { dateCreate: string }) => row.dateCreate,
    },
    {
      name: "Status",
      selector: (row: { status: string }) => {
        return row.status === "open" ? (
          <span className="status status-blue cursor-pointer">
            Open
          </span>
        ) : row.status === "Ready to Check in" ? (
          <span className="status status-blue cursor-pointer">
            Ready to Check-in
          </span>
        ) : (
          <></>
        );
      },
    },
    {
      name: (
        <>
            <ArrowLeftRight className="me-2" /> <PlusCircle />
        </>
    ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu list-ellipse-ms "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelEditAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelDetailsAction(row)}
            >
              Details
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelInactiveAction(row)}
            >
              Inactive
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={handelDeleteAction}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];
  const handelEditAction = (data: any) => {
    // navigation(`/PurchaseOrderDetails/${data.poId}`)
  };
  const handelDetailsAction = (data: any) => {
    navigation(`/inbound/purchase-order/details/${data.poId}`);
  };
  const handelInactiveAction = (data: any) => {};
 
  const handelSelectRows = (selectedRow: Set<number>) => {
    setAddButtonDisable(selectedRow.size > 0);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handelRemoveYesBtn = () => {
    setShowModal(false);
    handleCloseModal();
  };
  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  const onModalSubmit = (response: boolean) => {
    console.log(response);
    handleconfClose();
  };
  return (
    <>
      <PageHeader
        isShowBackBtn={true}
        setShowModalForImportAndExport={setShowModalForImportAndExport}
        showModalForImportAndExport={showModalForImportAndExport}
      />

      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div className="inbound-CheckIn-Table-Main-Div"></div>
      <Table
      customClassName="sph-table-color"
        columns={columns}
        data={inboundPurchaseOrderList}
         pagination={{
          recordsPerPage: 15,
          totalRecords: inboundPurchaseOrderList.length,
          onCurrentPageChange: onCurrentPageChange
        }}
        handleRowClick={handelEditAction}
        onSelectedRowsChange={handelSelectRows}
      />
      <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonConfirmationModal
      customClassName="header-border"
        show={showconfModal}
        content={<>You are about to delete purchase order <br />
        Are you Sure?</>}  
        confirmBtnText="Yes"
        cancelBtnText="No"
        onModalSubmit={onModalSubmit}
      />

    </>
  );
}
